import { gql } from '@apollo/client';

const CartTypeQuery = gql`
  query CartTypeQuery($language: Language, $testmode: Boolean) {
    user(language: $language, testmode: $testmode) {
      id
      cart {
        id
        reservedOrderNumber
        type
      }
    }
  }
`;

const cartFragment = gql`
  fragment cart on Cart {
    id
    billingAddress {
      id
      customerAddress {
        id
      }
      firstName
      lastName
      company
      street
      zip
      city
      country
      phone
    }
    shippingAddress {
      id
      customerAddress {
        id
      }
      firstName
      lastName
      company
      street
      zip
      city
      country
      phone
    }
    items {
      id
      product {
        id
        sku
        title
        isDownload
      }
      amount
    }
    isActive
    type
  }
`;

const setCartBillingAddress = gql`
  ${cartFragment}

  mutation setCartBillingAddress($cartId: ID!, $customerAddressId: ID!) {
    user {
      id
      cart(id: $cartId) {
        id
        setCartBillingAddress(customerAddressId: $customerAddressId) {
          ...cart
        }
      }
    }
  }
`;

const setCartShippingAddress = gql`
  ${cartFragment}

  mutation setCartShippingAddress(
    $cartId: ID!
    $customerAddressId: ID!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        setCartShippingAddress(customerAddressId: $customerAddressId) {
          ...cart
        }
      }
    }
  }
`;

const addAndSetCartShippingAddress = gql`
  ${cartFragment}

  mutation addAndSetCartShippingAddress(
    $cartId: ID!
    $address: CustomerAddressInputData!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        addAndSetCartShippingAddress(address: $address) {
          ...cart
        }
      }
    }
  }
`;

const addAndSetCartBillingAddress = gql`
  ${cartFragment}

  mutation addAndSetCartBillingAddress(
    $cartId: ID!
    $address: CustomerAddressInputData!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        addAndSetCartBillingAddress(address: $address) {
          ...cart
        }
      }
    }
  }
`;

const addBothNewAddresses = gql`
  ${cartFragment}

  mutation addBothNewAddresses(
    $cartId: ID!
    $address: CustomerAddressMultiInputData!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        addBothNewAddresses(address: $address) {
          ...cart
        }
      }
    }
  }
`;

const addAndSetAsBothShippingAndBillingAddress = gql`
  ${cartFragment}

  mutation addAndSetAsBothShippingAndBillingAddress(
    $cartId: ID!
    $address: CustomerAddressInputData!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        addAndSetAsBothShippingAndBillingAddress(address: $address) {
          ...cart
        }
      }
    }
  }
`;

const setCartShippingOption = gql`
  mutation setCartShippingOption(
    $cartId: ID!
    $shippingOptionId: ID!
    $language: Language
    $testmode: Boolean
  ) {
    user(language: $language, testmode: $testmode) {
      id
      cart(id: $cartId) {
        id
        setCartShippingOption(shippingOptionId: $shippingOptionId) {
          id
          shippingMethod {
            id
            title
          }
        }
      }
    }
  }
`;

export {
  CartTypeQuery,
  setCartBillingAddress,
  setCartShippingAddress,
  addAndSetCartShippingAddress,
  addAndSetCartBillingAddress,
  addBothNewAddresses,
  addAndSetAsBothShippingAndBillingAddress,
  setCartShippingOption,
  cartFragment,
};
